import { ColumnDef } from "@tanstack/react-table"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React from "react"
import { FormattedNumber } from "react-intl"
import { getTotalsValue } from ".."
import { CurrencyColumnDefinition, TableRowData } from "../../../../../../state/listing/generic-listing/column-definitions"
import SearchTotals from "../../../../../../state/search/SearchTotals"
import Icon from "../../../../../icon/icon.component"

export default (columnDefinition: CurrencyColumnDefinition, totals: SearchTotals | undefined): Partial<ColumnDef<TableRowData>> => ({
    footer: () => {
        const currency = AppContext.getAccount().attributes.currency
        let value = getTotalsValue(columnDefinition.totalAttributes?.key ?? "", totals)

        if (value && columnDefinition.totalAttributes?.parseValue) {
            value = columnDefinition.totalAttributes?.parseValue(value)
        }   

        if (columnDefinition.dataAttributes?.showPaidAmount  ?? false) {
            const paidAmount = getTotalsValue(`totals.${columnDefinition.dataAttributes?.paidAmountKey ?? ""}`, totals)

            return (
                <div className="d-flex align-items-center justify-content-end">
                    {parseFloat(paidAmount) > 0 ? (
                        <div className="badge badge-pill badge-secondary mr-2">
                            <Icon value="coins" className="mr-1" />
                            <FormattedNumber
                                style="currency"
                                currency={currency}
                                value={paidAmount}
                            />
                        </div>
                    ) : (
                        <div></div>
                    )}
                    <div>
                        <FormattedNumber
                            style="currency"
                            currency={currency}
                            value={value}
                        />
                    </div>
                </div>
            )
        }

        return (
            <FormattedNumber
                style="currency"
                currency={currency}
                value={value}
            />
        )
    }
})


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/listing-table/mappers/total-mappers/CurrencyTotalMapper.tsx